import React, { useCallback, useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import { Scanner } from '../../components/TicketAdmin';
import { getAPI } from '../../api';
import { ticketPages } from '../../api/ticketPages';

// Vista de puerta para usuarios de taquilla (y administración): solo funciones próximas y datos mínimos de sus pedidos.
export default function Taquilla() {
  const [functions, setFunctions] = useState([]); const [orders, setOrders] = useState([]);
  const [notice, setNotice] = useState(''); const [loading, setLoading] = useState(true);
  const current = useRef('');
  const loadOrders = useCallback(async funcionId => {
    current.current = funcionId; setOrders([]);
    if (!funcionId) return;
    try { const rows = await ticketPages(`taquilla/pedidos?funcionId=${funcionId}`); if (current.current === funcionId) setOrders(rows); }
    catch (e) { if (current.current === funcionId) setNotice(e.message); }
  }, []);
  const reload = useCallback(async () => {
    setLoading(true); setNotice('');
    try { setFunctions(await getAPI('taquilla/funciones')); await loadOrders(current.current); }
    catch (e) { setNotice(e.message); } finally { setLoading(false); }
  }, [loadOrders]);
  useEffect(() => { reload(); }, [reload]);
  return <Layout><main className="ticket-admin"><h1>Taquilla</h1>
    <button onClick={reload} disabled={loading}>Actualizar</button>
    <p role="status">{notice}</p>{loading && <p>Cargando…</p>}
    {!loading && !functions.length && !notice && <p>No hay funciones próximas.</p>}
    <Scanner functions={functions} orders={orders} onFunction={loadOrders} />
  </main></Layout>;
}
